/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import Chart from 'chart.js/auto';
import './LicenseSummaryView.css';

class licenseSummaryView extends Component {
  constructor(props) {
    super(props);
    this.licenseStatusChart = null;
    this.litigatorStatusChart = null;
  }

  componentDidMount() {
    if (this.licenseLineChart) {
      this.drawLicenseLineChart();
    }

    if (this.litigatorLineChart) {
      this.drawLitigatorLineChart();
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    if (this.licenseStatusChart) {
      this.licenseStatusChart.destroy();
    }
    if (this.litigatorStatusChart) {
      this.litigatorStatusChart.destroy();
    }
  }

  calcPercentages = (hiddenArray, data) => {
    const percentageData = [];
    let i = 0;

    for (i; i < data.length; i++) {
      percentageData.push([]);
    }

    Object.keys(data[0]).forEach((innerKey) => {
      let sum = 0;
      Object.keys(data).forEach((outerKey) => {
        sum += data[outerKey][innerKey];
      });

      Object.keys(data).forEach((outerKey) => {
        if (hiddenArray[outerKey]) {
          percentageData[outerKey][innerKey] = 0;
        } else {
          percentageData[outerKey][innerKey] = (data[outerKey][innerKey] / sum) * 100;
          if (isNaN(parseFloat(percentageData[outerKey][innerKey]))) {
            percentageData[outerKey][innerKey] = 0;
          }
        }
      });
    });
    return percentageData;
  };

  drawLicenseLineChart() {
    const { translate } = this.props;

    if (this.licenseStatusChart) {
      this.licenseStatusChart.destroy();
      this.licenseStatusChart = null;
    }

    const { trendOfLicense } = this.props.file;
    const dataSet = [];

    const undecidedArray = trendOfLicense.map((item) => {
      return item.undecided;
    });

    dataSet.push(undecidedArray);

    const resolvedArray = trendOfLicense.map((item) => {
      return item.resolved;
    });

    dataSet.push(resolvedArray);

    const disregardedArray = trendOfLicense.map((item) => {
      return item.disregarded;
    });

    dataSet.push(disregardedArray);

    const hiddenArray = [];
    let i = 0;

    for (i; i < dataSet.length; i++) {
      hiddenArray.push(null);
    }

    const percentageData = this.calcPercentages(hiddenArray, dataSet);

    const monthArray = trendOfLicense.map((item) => {
      return item.month;
    });

    const config = {
      type: 'line',
      data: {
        labels: monthArray,
        datasets: [
          {
            backgroundColor: '#21beff',
            borderColor: '#21beff',
            label: translate('chart.title.undecided'),
            borderWidth: 1,
            data: percentageData[0],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#61e286',
            borderColor: '#61e286',
            label: translate('chart.title.resolved'),
            data: percentageData[1],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#D0D0D0',
            borderColor: '#D0D0D0',
            label: translate('chart.title.disregarded'),
            borderWidth: 1,
            data: percentageData[2],
            fill: true,
            pointStyle: false,
          },
        ],
      },
      options: {
        plugins: {
          /*
          title: {
            display: true,
            position: 'top',
            text: translate('dashboard.trend_security_issue_status'),
            color: '#ffffff',
            font: {
              size: 8,
            }
          },
          */
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += `${Math.round(context.parsed.y)}%`;
                }

                return label;
              }
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              color: '#ffffff',
              font: {
                size: 9,
              }
            },
          },
        },
        layout: {
          padding: 5,
        },
        scales: {
          y: {
            type: 'linear',
            grace: '5%',
            stacked: true,
            min: 0,
            max: 100,
            ticks: {
              padding: 2,
              font: {
                size: 9,
              },
              color: '#afafaf',
              callback(value) {
                return `${value}%`;
              }
            },
          },
          x: {
            lineHeight: '50px',
            ticks: {
              padding: 5,
              font: {
                size: 9,
              },
              color: '#afafaf',
            },
          },
        },
      },
    };

    const ctx = this.licenseLineChart.getContext('2d');
    this.licenseStatusChart = new Chart(ctx, config);
  }

  drawLitigatorLineChart() {
    const { translate } = this.props;

    if (this.litigatorStatusChart) {
      this.litigatorStatusChart.destroy();
      this.litigatorStatusChart = null;
    }

    const { trendOfLitigator } = this.props.file;
    const dataSet = [];

    const undecidedArray = trendOfLitigator.map((item) => {
      return item.undecided;
    });

    dataSet.push(undecidedArray);

    const resolvedArray = trendOfLitigator.map((item) => {
      return item.resolved;
    });

    dataSet.push(resolvedArray);

    const disregardedArray = trendOfLitigator.map((item) => {
      return item.disregarded;
    });

    dataSet.push(disregardedArray);

    const hiddenArray = [];
    let i = 0;

    for (i; i < dataSet.length; i++) {
      hiddenArray.push(null);
    }

    const percentageData = this.calcPercentages(hiddenArray, dataSet);

    const monthArray = trendOfLitigator.map((item) => {
      return item.month;
    });

    const config = {
      type: 'line',
      data: {
        labels: monthArray,
        datasets: [
          {
            backgroundColor: '#21beff',
            borderColor: '#21beff',
            label: translate('chart.title.undecided'),
            data: percentageData[0],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#61e286',
            borderColor: '#61e286',
            label: translate('chart.title.resolved'),
            data: percentageData[1],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#D0D0D0',
            borderColor: '#D0D0D0',
            label: translate('chart.title.disregarded'),
            data: percentageData[2],
            fill: true,
            pointStyle: false,
          },
        ],
      },
      options: {
        plugins: {
          /*
          title: {
            display: true,
            position: 'top',
            text: translate('dashboard.trend_security_issue_status'),
            color: '#ffffff',
            font: {
              size: 8,
            }
          },
          */
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += `${Math.round(context.parsed.y)}%`;
                }

                return label;
              }
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              color: '#ffffff',
              font: {
                size: 9,
              }
            },
          },
        },
        scales: {
          y: {
            type: 'linear',
            grace: '5%',
            stacked: true,
            min: 0,
            max: 100,
            ticks: {
              padding: 2,
              font: {
                size: 9,
              },
              color: '#afafaf',
              callback(value) {
                return `${value}%`;
              }
            },
          },
          x: {
            lineHeight: '50px',
            ticks: {
              padding: 5,
              font: {
                size: 9,
              },
              color: '#afafaf',
            },
          },
        },
      },
    };

    const ctx = this.litigatorLineChart.getContext('2d');
    this.litigatorStatusChart = new Chart(ctx, config);
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  render() {
    const { translate } = this.props;

    return (
      <table className="license_summary summary_item_table small">
        <colgroup>
          <col width="20%" />
          <col width="29.5%" />
          <col width="1px" />
          <col width="20%" />
          <col width="29.5%" />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.license')}</p>
                <p className="value">{this.abbreviateNumber(this.props.file.licenseCount.total)}</p>
              </div>
              <div className="summary_chart bubble_chart">
                <div className="">
                  <div className="inner red">
                    {this.abbreviateNumber(this.props.file.licenseCount.protective)}
                  </div>
                </div>
                <div>
                  <div className="inner cheese">
                    {this.abbreviateNumber(this.props.file.licenseCount.permissive)}
                  </div>
                </div>
                <div>
                  <div className="inner yellow">
                    {this.abbreviateNumber(this.props.file.licenseCount.others)}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div
                className="summary_chart line"
                style={{
                  width: '250px', height: '100px', position: 'relative', marginLeft: '8px'
                }}
              >
                <canvas
                  className="line_chart"
                  ref={(ref) => { this.licenseLineChart = ref; }}
                />
              </div>
            </td>
            <td>
              <div className="bg_stick" />
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.litigator')}</p>
                <p className="value">{this.props.file.litgatorCount}</p>
              </div>
            </td>
            <td>
              <div
                className="summary_chart line"
                style={{
                  width: '250px', height: '100px', position: 'relative', marginLeft: '8px'
                }}
              >
                <canvas
                  className="line_chart"
                  ref={(ref) => { this.litigatorLineChart = ref; }}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
licenseSummaryView.defaultProps = {
  file: {},
};

export default licenseSummaryView;
